/* ============================
   RIFTED APPAREL — THEME JS
   Shopify Compatible
   ============================ */

document.addEventListener('DOMContentLoaded', () => {

  // ============================
  // LOADER
  // ============================
  const loader = document.getElementById('loader');
  const loaderFill = document.getElementById('loader-fill');

  if (loader) {
    let loadProgress = 0;
    const loadInterval = setInterval(() => {
      loadProgress += Math.random() * 18 + 6;
      if (loadProgress >= 100) {
        loadProgress = 100;
        if (loaderFill) loaderFill.style.width = '100%';
        clearInterval(loadInterval);
        setTimeout(() => {
          loader.classList.add('hidden');
          document.body.style.overflow = 'auto';
          triggerHeroReveal();
          animateCounters();
        }, 450);
      }
      if (loaderFill) loaderFill.style.width = loadProgress + '%';
    }, 70);
    document.body.style.overflow = 'hidden';
  } else {
    triggerHeroReveal();
  }

  function triggerHeroReveal() {
    document.querySelectorAll('.reveal, [class*="reveal-delay"]').forEach(el => {
      el.classList.add('revealed');
    });
  }

  // ============================
  // CUSTOM CURSOR (desktop only)
  // ============================
  if (window.innerWidth > 768) {
    const cursor = document.getElementById('cursor');
    const follower = document.getElementById('cursor-follower');
    let mouseX = 0, mouseY = 0, followerX = 0, followerY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (cursor) { cursor.style.left = mouseX + 'px'; cursor.style.top = mouseY + 'px'; }
    });

    function animateFollower() {
      followerX += (mouseX - followerX) * 0.1;
      followerY += (mouseY - followerY) * 0.1;
      if (follower) { follower.style.left = followerX + 'px'; follower.style.top = followerY + 'px'; }
      requestAnimationFrame(animateFollower);
    }
    animateFollower();

    document.querySelectorAll('a, button, .product-card, .gc-card, .look-item').forEach(el => {
      el.addEventListener('mouseenter', () => {
        if (cursor) { cursor.style.width = '20px'; cursor.style.height = '20px'; cursor.style.background = 'var(--blue-accent)'; }
        if (follower) { follower.style.width = '60px'; follower.style.height = '60px'; follower.style.borderColor = 'rgba(44,111,209,0.5)'; }
      });
      el.addEventListener('mouseleave', () => {
        if (cursor) { cursor.style.width = '10px'; cursor.style.height = '10px'; cursor.style.background = 'var(--white)'; }
        if (follower) { follower.style.width = '36px'; follower.style.height = '36px'; follower.style.borderColor = 'rgba(255,255,255,0.4)'; }
      });
    });
  }

  // ============================
  // SCROLL NAV
  // ============================
  const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });

  // ============================
  // MOBILE MENU
  // ============================
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      const spans = hamburger.querySelectorAll('span');
      spans[0].style.transform = open ? 'rotate(45deg) translate(5px, 5px)' : '';
      spans[1].style.opacity = open ? '0' : '';
      spans[2].style.transform = open ? 'rotate(-45deg) translate(5px, -5px)' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        hamburger.querySelectorAll('span').forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
      });
    });
  }

  // ============================
  // SCROLL REVEAL
  // ============================
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-delay') || 0;
        setTimeout(() => entry.target.classList.add('in-view'), parseInt(delay));
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.scroll-reveal').forEach(el => revealObserver.observe(el));

  // ============================
  // STAT COUNTERS
  // ============================
  function animateCounters() {
    document.querySelectorAll('.stat-num[data-target]').forEach(counter => {
      const target = parseInt(counter.getAttribute('data-target'));
      let current = 0;
      const step = target / (1800 / 16);
      const timer = setInterval(() => {
        current += step;
        if (current >= target) { current = target; clearInterval(timer); }
        counter.textContent = Math.floor(current).toLocaleString();
      }, 16);
    });
  }

  // ============================
  // PARALLAX HERO
  // ============================
  const heroGrid = document.querySelector('.hero-grid');
  window.addEventListener('scroll', () => {
    if (heroGrid) heroGrid.style.transform = `translateY(${window.scrollY * 0.2}px)`;
  }, { passive: true });

  // ============================
  // GIFT CARD 3D TILT
  // ============================
  document.querySelectorAll('.gc-card').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width - 0.5) * 14;
      const y = ((e.clientY - rect.top) / rect.height - 0.5) * -14;
      card.style.transform = `perspective(600px) rotateY(${x}deg) rotateX(${y}deg) translateY(-8px)`;
    });
    card.addEventListener('mouseleave', () => { card.style.transform = ''; });
  });

  // ============================
  // PRODUCT CARD MAGNETIC
  // ============================
  document.querySelectorAll('.product-card').forEach(card => {
    const img = card.querySelector('.product-img, .product-real-img');
    if (!img) return;
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width - 0.5) * 8;
      const y = ((e.clientY - rect.top) / rect.height - 0.5) * -8;
      img.style.transform = `scale(1.06) translate(${x * 0.5}px, ${y * 0.5}px)`;
    });
    card.addEventListener('mouseleave', () => { img.style.transform = ''; });
  });

  // ============================
  // AJAX QUICK ADD TO CART
  // ============================
  document.querySelectorAll('.quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        flashBtn(btn, '✓ ADDED');
        return;
      }
      btn.textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          flashBtn(btn, '✓ ADDED');
          const cartData = await (await fetch('/cart.js')).json();
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) {
            cartCount.textContent = cartData.item_count;
            cartCount.style.background = 'var(--blue-accent)';
            setTimeout(() => cartCount.style.background = '', 600);
          }
        } else {
          flashBtn(btn, 'SOLD OUT', '#555');
        }
      } catch (err) {
        flashBtn(btn, 'QUICK ADD');
      }
    });
  });

  function flashBtn(btn, text, bg = 'var(--blue-accent)') {
    const orig = btn.getAttribute('data-orig') || btn.textContent;
    btn.setAttribute('data-orig', orig);
    btn.textContent = text;
    btn.style.background = bg;
    btn.style.color = 'white';
    setTimeout(() => {
      btn.textContent = orig;
      btn.style.background = '';
      btn.style.color = '';
    }, 1800);
  }

  // ============================
  // PRODUCT PAGE — ADD TO CART
  // ============================
  const productForm = document.querySelector('.product-page form');
  const addBtn = productForm && productForm.querySelector('[name="add"]');
  if (productForm && addBtn) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = productForm.querySelector('[name="id"]').value;
      addBtn.textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          addBtn.textContent = '✓ ADDED TO CART';
          addBtn.style.background = 'var(--blue-accent)';
          addBtn.style.borderColor = 'var(--blue-accent)';
          const cartData = await (await fetch('/cart.js')).json();
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) cartCount.textContent = cartData.item_count;
          setTimeout(() => {
            addBtn.textContent = 'Add to Cart';
            addBtn.style.background = '';
            addBtn.style.borderColor = '';
          }, 2200);
        } else {
          addBtn.textContent = 'SOLD OUT';
          setTimeout(() => addBtn.textContent = 'Add to Cart', 2000);
        }
      } catch (err) {
        addBtn.textContent = 'Add to Cart';
      }
    });
  }

  // ============================
  // VARIANT SELECTION
  // ============================
  document.querySelectorAll('.variant-btn').forEach(label => {
    label.addEventListener('click', () => {
      document.querySelectorAll('.variant-btn').forEach(l => l.classList.remove('selected'));
      label.classList.add('selected');
    });
  });

  // ============================
  // SMOOTH ANCHORS
  // ============================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

});
